import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomZoomTriggerComponent } from './custom-zoom-trigger/custom-zoom-trigger.component';
import { IconModule } from '@spartacus/storefront';

@NgModule({
  declarations: [CustomZoomTriggerComponent],
  imports: [CommonModule, IconModule],
  exports: [CustomZoomTriggerComponent],
})
export class ZoomModule {}
